import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";

export default function Layout() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    const routePath = pathname.replace(/\/+$/, "") || "/";
    const labels = { "/": "Welcome", "/learn": "Learning Center", "/free-apps": "Your Free Apps", "/community": "Community & Events", "/resources": "Resource Library", "/certification": "Earn a Certificate", "/legal": "Legal Resources", "/about": "About", "/contact": "Contact", "/register": "Free Membership", "/login": "Member Login" };
    document.title = `${labels[routePath] || (routePath.startsWith("/dashboard") ? "My Wolfdog Village" : "Learn")} | Wolfdog Village`;
    let canonical=document.querySelector('link[rel="canonical"]');
    if(!canonical) { canonical=document.createElement("link"); canonical.rel="canonical"; document.head.appendChild(canonical); }
    canonical.href="https://wolfdogvillage.com"+routePath;
    let robots=document.querySelector('meta[name="robots"]');
    if(!robots) { robots=document.createElement("meta"); robots.name="robots"; document.head.appendChild(robots); }
    robots.content=["/dashboard","/member-callback","/login","/register","/verify-email","/forgot-password","/reset-password"].some(p=>pathname===p||pathname.startsWith(p+"/"))?"noindex, nofollow":"index, follow";

  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
